import {
  useEffect,
  PropsWithChildren,
} from 'react';
import isNil from 'lodash/isNil';
import {
  RoomStatusUpdatedNotificationDTO,
} from 'dtos';
import {
  settingsEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import useSignalREffect from 'views/EMR/hooks/signalR';
import {
  useAppointmentStatusActions,
} from 'views/EMR/stores/appointmentStatus';
import useEMRAccess from 'views/EMR/hooks/useEMRAccess';
import {
  EMR_PATHS,
} from 'views/EMR/access';

export default function StoreProvider({ children }: PropsWithChildren) {
  const { userInfo, canPath, isRestricted } = useEMRAccess();
  const shouldFetchAppointmentStatuses = !isNil(userInfo) && canPath(EMR_PATHS.ENCOUNTERS);
  const shouldFetchRoomStatuses = !isRestricted;
  const {
    fetchAppointmentStatuses,
    applyRoomStatusUpdate,
  } = useAppointmentStatusActions();

  useEffect(() => {
    if (shouldFetchAppointmentStatuses) {
      fetchAppointmentStatuses({ includeRoomStatuses: shouldFetchRoomStatuses });
    }
  }, [fetchAppointmentStatuses, shouldFetchAppointmentStatuses, shouldFetchRoomStatuses]);

  useEffect(() => {
    if (!shouldFetchAppointmentStatuses) return undefined;

    const unsubscribe = settingsEventChannel.on('onRoomSettingsChange', () => {
      fetchAppointmentStatuses({ includeRoomStatuses: shouldFetchRoomStatuses });
    });
    return () => {
      unsubscribe();
    };
  }, [fetchAppointmentStatuses, shouldFetchAppointmentStatuses, shouldFetchRoomStatuses]);

  useSignalREffect(
    'OnRoomStatusUpdated',
    (notification: RoomStatusUpdatedNotificationDTO) => {
      applyRoomStatusUpdate(notification);
    },
    [applyRoomStatusUpdate],
  );

  return children;
}
